
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/downloadapp",
      function () {
        return require("private-next-pages/downloadapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/downloadapp"])
      });
    }
  